// Single source of truth for the MFE (ops) iframe paths. The main app builds these paths with
// mfePaths and embeds them via MfeFrame; the ops app declares the matching react-router patterns
// with mfeRoutePatterns. Keeping the builders and the patterns in one file stops the two apps
// from drifting apart silently.

export const mfePaths = {
  view: (dashboardId: string, viewId: string, dataPipelineConfigurationId: string): string =>
    `/dashboard/${dashboardId}/view/${viewId}/${encodeURIComponent(dataPipelineConfigurationId)}`,

  widget: (dashboardId: string, viewId: string, widgetId: string, dataPipelineConfigurationId: string, filters: Record<string, string>): string => {
    const queryString = new URLSearchParams(filters).toString();
    return `/dashboard/${dashboardId}/view/${viewId}/widget/${widgetId}/${encodeURIComponent(dataPipelineConfigurationId)}${queryString ? `?${queryString}` : ""}`;
  },
};

// react-router path patterns matching the builders above. The param names are the keys the ops
// route components read via useParams.
export const mfeRoutePatterns = {
  view: "/dashboard/:dashboardId/view/:viewId/:dataPipelineConfigurationId",
  widget: "/dashboard/:dashboardId/view/:viewId/widget/:widgetId/:dataPipelineConfigurationId",
};
